<fu-icon
  [iconName]="iconName()"
  size="20"
  [fuPopover]="popover"
  [position]="['tc', 'bc']"
  [offsetY]="2" />

<ng-template #popover>
  <div class="kr-tooltip">
    <span
      class="kr-details__value"
      [class.kr-details__value_hover]="copy()"
      (click)="copy() && clipboard.copy(text())"
      [attr.data-testid]="text() | safeHtml">
      <span [innerHtml]="text() | safeHtml"></span>
      @if (copy()) {
        <fu-icon iconName="copy" size="16" />
      }
    </span>
  </div>
</ng-template>
